import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import classNames from "classnames/bind";
import styles from "./NodeEl.module.scss";
let cx = classNames.bind(styles);


interface NodeElProps {
  data: DataProps
}
interface DataProps {
  title: string;
  status?: "info" | "error" | "success" ;
  risks?: number;
  controls?: number;
}



export default function NodeEl({ data }: NodeElProps) {

  let nodeElStyle = cx({
    node: true,
    info: data.status === "info",
    error: data.status === "error",
    success: data.status === "success"
  }); 

  return (
    <div className={nodeElStyle}>
      <h4>{data.title}</h4>
      <p>
        {data.risks && data.risks + " risks "}
        {data.risks && data.controls && ' | ' }
        {data.controls && data.controls + " controls "}
      </p>
      <Handle
        type="target"
        position={Position.Left}
        className="w-16 !bg-teal-500"
      />
      <Handle
        type="source"
        position={Position.Right}
        className="w-16 !bg-teal-500"
      />
    </div>
  );
}
